<template>
    <div class="app-upload">
        <el-upload
            ref="upload"
            :action="action"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :multiple="multiple"
            :show-file-list="false"
            :type="type"
            accept=".png, .jpg, .svg">
            <slot name="target"></slot>
        </el-upload>
        <el-dialog :visible="dialogVisible" @close="onClose" custom-class="upload-dialog" class="global-dialog" append-to-body>
            <el-progress color="#1BD18E" :stroke-width="4" :width="80" type="circle" :percentage="percentage"></el-progress>
            <div class="upload-progress">
                <div>文件上传中...</div>
                <div>{{hasUpload}}/{{totalUpload}}</div>
            </div>
            <span slot="footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import materialService from '../../../request/service/material-service'
import { material_type as types } from '@/const.js'
import {MATERIAL_UPLOAD} from '../../../request/api/fileupload-api'
import util from '@/util'
export default {
    props: {
        action: {type: String, required: false, default: MATERIAL_UPLOAD},
        multiple: {type: Boolean, default: true},
        showList: {type: Boolean, default: true},
        type: {type: String, default: types.element, validator: (value) => {
            return Object.values(types).indexOf(value) !== -1;
        }},
        projectId: String,
    },
    data () {
        return {
            index: 0,
            itemArray: [],
            percentage: 0,
            hasUpload: 0,
            totalUpload: 0,
            dialogVisible: false,
            progressList: []
        }
    },
    methods: {
        beforeUpload () {
            this.$emit('beforeUplad');
            this.dialogVisible = true;
        },
        async uploadSuccess (res, file, fileList) {
            if (res.code != 200) {
              this.$emit('error', {message: file.name + '上传失败'});
              this.dialogVisible = false;
              return;
            }
            let htmlStr = util.isSvg(file.raw) ?  await util.getSvgHtml(file.raw): '';
            let {width, height} = util.getWidthAndHeight(res.result.properties);
            htmlStr = util.setSvgViewBox(htmlStr, width, height);
            this.itemArray.push({
                name: res.result.displayName.split('.')[0],
                url: res.result.url,
                storageId: res.result.id,
                widthHeight: res.result.properties ? res.result.properties : '0x0',
                html: htmlStr
            });
            this.totalUpload = fileList.length;
            this.index += 1;
            if (this.index === fileList.length) {
                let param = {
                    projectId: this.projectId,
                    type: this.type,
                    items: this.itemArray,
                }
                materialService.batchSaveMaterial(param).then((data) => {
                    this.percentage = 100;
                    this.hasUpload += 1;
                    this.index = 0;
                    this.itemArray = [];
                    setTimeout(() => {
                        this.dialogVisible = false;
                        this.$emit('success', data);
                    }, 400);
                }).catch(() => {
                    this.$emit('error', {message: file.name + '服务器保存失败'});
                }).finally(() => {
                    this.$refs.upload.clearFiles();
                });
            }
        },
        uploadError (err, file) {
            this.$emit('error', {message: file.name + '上传失败'});
        },
        sum(arr) {
            return arr.reduce(function (prev, curr, idx, arr) {
                return prev + curr;
            });
        },
        onProgress({percent}, file, fileList){
            if(this.totalUpload === 0 ){
                this.totalUpload = fileList.length;
            }
            let total = this.progressList.length > 0 ? this.sum(this.progressList) : 0;
            let progress = (total + percent) / (fileList.length * 100);
            let percentage = parseInt(progress * 100);
            if(percentage === 100){ //上传完后需要调用批量保存接口，100%进度值放在保存完成后
                this.percentage = 99;
                return;
            }else {
                this.percentage = percentage;
            }
            if(percent === 100){
                this.hasUpload += 1;
                this.progressList.push(100);
            }
        },
        clearData(){
            this.percentage = 0;
            this.hasUpload = 0;
            this.totalUpload = 0;
            this.progressList = [];
            this.itemArray  = [];
            this.$refs.upload.clearFiles();
        },
        onClose(){
            this.clearData();
        }
    }
}
</script>
<style lang="scss">
@import "index";
</style>


